import { Link } from "react-router-dom";

// Constants and Utils
import { constructRedirectPath } from "../../../utils/redirect-utils/RedirectUtils";

/**
 * CityConfigSidebar
 */
export default function CityConfigSidebar({ activePageUrl = "" }) {
  // constants
  const sidebarConstants = [
    {
      label: "Media Types",
      pageUrl: "/city-config/media-types",
      icon: "fa-image",
    },
    {
      label: "Touch Points",
      pageUrl: "/city-config/touch-points",
      icon: "fa-hand-pointer",
    },
    {
      label: "Zones",
      pageUrl: "/city-config/zones",
      icon: "fa-border-all",
    },
    {
      label: "Sub Zones",
      pageUrl: "/city-config/sub-zones",
      icon: "fa-border-none",
    },
  ];

  return (
    <aside className="sidebar bg-alt">
      <ul className="nav flex-column mt-3">
        <li className="nav-item group-header">Configurations</li>
        {sidebarConstants.map((info, i) => {
          const { pageUrl, label, icon } = info;
          const activeClassName = activePageUrl === pageUrl && "active";

          return (
            <li key={i} className={`nav-item ${activeClassName}`}>
              <Link className="nav-link" to={constructRedirectPath(pageUrl)}>
                <i className={`fas ${icon} text-primary`}></i> {label}
              </Link>
            </li>
          );
        })}
      </ul>
    </aside>
  );
}
